import { Action } from '@ngrx/store';

export enum AnalyticsActionTypes {
  INIT_ANALYTICS_DATA = '[Cyclops Analytics] Init Analytics',
  CREATE_VISITOR_TICKET = '[Cyclops Analytics] Create Visitor Ticket',
  CREATE_VISITOR_TICKET_SUCCESS = '[Cyclops Analytics] Create Visitor Ticket Success',
  CREATE_VISITOR_TICKET_FAILURE = '[Cyclops Analytics] Create Visitor Ticket Failure',
  GET_VISITOR_TICKET = '[Cyclops Analytics] Get Visitor Ticket',
  GET_VISITOR_TICKET_SUCCESS = '[Cyclops Analytics] Get Visitor Ticket Success',
  GET_VISITOR_TICKET_FAILURE = '[Cyclops Analytics] Get Visitor Ticket Failure',
  GET_INCIDENT_TICKET = '[Cyclops Analytics] Get Incident Ticket',
  GET_INCIDENT_TICKET_SUCCESS = '[Cyclops Analytics] Get Incident Ticket Success',
  GET_INCIDENT_TICKET_FAILURE = '[Cyclops Analytics] Get Incident Ticket Failure',
  CREATE_INCIDENT_TICKET = '[Cyclops Analytics] Create Incident Ticket',
  CREATE_INCIDENT_TICKET_SUCCESS = '[Cyclops Analytics] Create Incident Ticket Success',
  CREATE_INCIDENT_TICKET_FAILURE = '[Cyclops Analytics] Create Incident Ticket Failure',
  SET_CONTEXT_DATA = '[Cyclops Analytics] Set Context Data',

  GET_COMPLAINTS_TICKET = '[Cyclops Analytics] Get Complaints Ticket',
  GET_COMPLAINTS_TICKET_SUCCESS = '[Cyclops Analytics] Get Complaints Ticket Success',
  GET_COMPLAINTS_TICKET_FAILURE = '[Cyclops Analytics] Get Complaints Ticket Failure',

  GET_CLAIM_TICKET = '[Cyclops Analytics] Get CLAIM Ticket',
  GET_CLAIM_TICKET_SUCCESS = '[Cyclops Analytics] Get CLAIM Ticket Success',
  GET_CLAIM_TICKET_FAILURE = '[Cyclops Analytics] Get CLAIM Ticket Failure',

  GET_REQUESTS_TICKET = '[Cyclops Analytics] Get REQUESTS Ticket',
  GET_REQUESTS_TICKET_SUCCESS = '[Cyclops Analytics] Get REQUESTS Ticket Success',
  GET_REQUESTS_TICKET_FAILURE = '[Cyclops Analytics] Get REQUESTS Ticket Failure',

  SAVE_RISK_PROFILE = '[Cyclops Analytics] Save Risk Profile',
  SAVE_RISK_PROFILE_SIM = '[Cyclops Analytics] Save Risk Profile Sim',
  SAVE_RISK_PROFILE_SUCCESS = '[Cyclops Analytics] Save Risk Profile Success',
  SAVE_RISK_PROFILE_FAILURE = '[Cyclops Analytics] Save Risk Profile Failure',

  GET_RISK_PROFILE = '[Cyclops Analytics] Get Risk Profile',
  GET_RISK_PROFILE_SUCCESS = '[Cyclops Analytics] Get Risk Profile Success',
  GET_RISK_PROFILE_FAILURE = '[Cyclops Analytics] Get Risk Profile Failure',

  GET_RISK_PROFILE_NEW = '[Cyclops Analytics] Get Risk Profile New',
  GET_RISK_PROFILE_SUCCESS_NEW = '[Cyclops Analytics] Get Risk Profile New Success',
  GET_RISK_PROFILE_FAILURE_NEW = '[Cyclops Analytics] Get Risk Profile New Failure',

  GET_VISITOR_ANALYTICS = '[Cyclops Analytics] Get Visitor Analytics',
  GET_VISITOR_ANALYTICS_SUCCESS = '[Cyclops Analytics] Get Visitor Analytics Success',
  GET_VISITOR_ANALYTICS_FAILURE = '[Cyclops Analytics] Get Visitor Analytics Failure',

  CREATE_ANALYTICS_DATA = '[Cyclops Analytics] Create Analytics Data',
  SAVE_ANALYTICS_DATA = '[Cyclops Analytics] Save Analytics Data',
  GET_ANALYTICS_DATA = '[Cyclops Analytics] Get Analytics Data',

  RESET_STATE = '[Cyclops Analytics] Reset State',
}
export class ResetState implements Action {
  readonly type = AnalyticsActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class CreateAnalyticsData implements Action {
  readonly type = AnalyticsActionTypes.CREATE_ANALYTICS_DATA;
  constructor(public payload: any) {}
}
export class SaveAnalyticsData implements Action {
  readonly type = AnalyticsActionTypes.SAVE_ANALYTICS_DATA;
  constructor(public payload: any) {}
}
export class GetAnalyticsData implements Action {
  readonly type = AnalyticsActionTypes.GET_ANALYTICS_DATA;
  constructor(public payload: any) {}
}
export class InitAnalyticsTab implements Action {
  readonly type = AnalyticsActionTypes.INIT_ANALYTICS_DATA;
  constructor(public payload: any) {}
}
export class SetContextData implements Action {
  readonly type = AnalyticsActionTypes.SET_CONTEXT_DATA;
  constructor(public payload: any) {}
}
export class CreateVisitorTicket implements Action {
  readonly type = AnalyticsActionTypes.CREATE_VISITOR_TICKET;
  constructor(public payload: any) {}
}
export class CreateVisitorTicketSuccess implements Action {
  readonly type = AnalyticsActionTypes.CREATE_VISITOR_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class CreateVisitorTicketFailed implements Action {
  readonly type = AnalyticsActionTypes.CREATE_VISITOR_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class GetVisitorTickets implements Action {
  readonly type = AnalyticsActionTypes.GET_VISITOR_TICKET;
  constructor(public payload: any) {}
}
export class GetVisitorTicketsSuccess implements Action {
  readonly type = AnalyticsActionTypes.GET_VISITOR_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class GetVisitorTicketsFailed implements Action {
  readonly type = AnalyticsActionTypes.GET_VISITOR_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class GetIncidentTickets implements Action {
  readonly type = AnalyticsActionTypes.GET_INCIDENT_TICKET;
  constructor(public payload: any) {}
}
export class GetIncidentTicketsSuccess implements Action {
  readonly type = AnalyticsActionTypes.GET_INCIDENT_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class GetIncidentTicketsFailed implements Action {
  readonly type = AnalyticsActionTypes.GET_INCIDENT_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class CreateIncidentTicket implements Action {
  readonly type = AnalyticsActionTypes.CREATE_INCIDENT_TICKET;
  constructor(public payload: any) {}
}
export class CreateIncidentTicketSuccess implements Action {
  readonly type = AnalyticsActionTypes.CREATE_INCIDENT_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class CreateIncidentTicketFailed implements Action {
  readonly type = AnalyticsActionTypes.CREATE_INCIDENT_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class GetComplaintsTickets implements Action {
  readonly type = AnalyticsActionTypes.GET_COMPLAINTS_TICKET;
  constructor(public payload: any) {}
}
export class GetComplaintsTicketsSuccess implements Action {
  readonly type = AnalyticsActionTypes.GET_COMPLAINTS_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class GetComplaintsTicketsFailed implements Action {
  readonly type = AnalyticsActionTypes.GET_COMPLAINTS_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class GetClaimTickets implements Action {
  readonly type = AnalyticsActionTypes.GET_CLAIM_TICKET;
  constructor(public payload: any) {}
}
export class GetClaimTicketsSuccess implements Action {
  readonly type = AnalyticsActionTypes.GET_CLAIM_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class GetClaimTicketsFailed implements Action {
  readonly type = AnalyticsActionTypes.GET_CLAIM_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class GetRequestsTickets implements Action {
  readonly type = AnalyticsActionTypes.GET_REQUESTS_TICKET;
  constructor(public payload: any) {}
}
export class GetRequestsTicketsSuccess implements Action {
  readonly type = AnalyticsActionTypes.GET_REQUESTS_TICKET_SUCCESS;
  constructor(public payload: any) {}
}
export class GetRequestsTicketsFailed implements Action {
  readonly type = AnalyticsActionTypes.GET_REQUESTS_TICKET_FAILURE;
  constructor(public payload: any) {}
}
export class SaveRiskProfileQuestions implements Action {
  readonly type = AnalyticsActionTypes.SAVE_RISK_PROFILE;
  constructor(public payload: any) {}
}
export class SaveRiskProfileSimQuestions implements Action {
  readonly type = AnalyticsActionTypes.SAVE_RISK_PROFILE_SIM;
  constructor(public payload: any) {}
}
export class SaveRiskProfileQuestionsSuccess implements Action {
  readonly type = AnalyticsActionTypes.SAVE_RISK_PROFILE_SUCCESS;
  constructor(public payload: any) {}
}
export class SaveRiskProfileQuestionsFailed implements Action {
  readonly type = AnalyticsActionTypes.SAVE_RISK_PROFILE_FAILURE;
  constructor(public payload: any) {}
}
export class GetRiskProfileQuestions implements Action {
  readonly type = AnalyticsActionTypes.GET_RISK_PROFILE;
  constructor(public payload: any) {}
}
export class GetRiskProfileQuestionsSuccess implements Action {
  readonly type = AnalyticsActionTypes.GET_RISK_PROFILE_SUCCESS;
  constructor(public payload: any) {}
}
export class GetRiskProfileQuestionsFailed implements Action {
  readonly type = AnalyticsActionTypes.GET_RISK_PROFILE_FAILURE;
  constructor(public payload: any) {}
}
export class GetRiskProfile implements Action {
  readonly type = AnalyticsActionTypes.GET_RISK_PROFILE_NEW;
  constructor(public payload: any) {}
}
export class GetRiskProfileNewSuccess implements Action {
  readonly type = AnalyticsActionTypes.GET_RISK_PROFILE_SUCCESS_NEW;
  constructor(public payload: any) {}
}
export class GetRiskProfileNewFailed implements Action {
  readonly type = AnalyticsActionTypes.GET_RISK_PROFILE_FAILURE_NEW;
  constructor(public payload: any) {}
}
export class GetVisitorAnalytics implements Action {
  readonly type = AnalyticsActionTypes.GET_VISITOR_ANALYTICS;
  constructor(public payload: any) {}
}
export class GetVisitorAnalyticsSuccess implements Action {
  readonly type = AnalyticsActionTypes.GET_VISITOR_ANALYTICS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetVisitorAnalyticsFailed implements Action {
  readonly type = AnalyticsActionTypes.GET_VISITOR_ANALYTICS_FAILURE;
  constructor(public payload: any) {}
}
export type CyclopsAnalyticsActionUnion =
  | ResetState
  | CreateAnalyticsData
  | SaveAnalyticsData
  | GetAnalyticsData
  | InitAnalyticsTab
  | SetContextData
  | CreateVisitorTicket
  | CreateVisitorTicketSuccess
  | CreateVisitorTicketFailed
  | CreateIncidentTicket
  | CreateIncidentTicketSuccess
  | CreateIncidentTicketFailed
  | GetVisitorTickets
  | GetVisitorTicketsSuccess
  | GetVisitorTicketsFailed
  | GetIncidentTickets
  | GetIncidentTicketsSuccess
  | GetIncidentTicketsFailed
  | GetComplaintsTickets
  | GetComplaintsTicketsSuccess
  | GetComplaintsTicketsFailed
  | GetClaimTickets
  | GetClaimTicketsSuccess
  | GetClaimTicketsFailed
  | GetRequestsTickets
  | GetRequestsTicketsSuccess
  | GetRequestsTicketsFailed
  | SaveRiskProfileQuestions
  | SaveRiskProfileSimQuestions
  | SaveRiskProfileQuestionsSuccess
  | SaveRiskProfileQuestionsFailed
  | GetRiskProfileQuestions
  | GetRiskProfileQuestionsSuccess
  | GetRiskProfileQuestionsFailed
  | GetVisitorAnalytics
  | GetVisitorAnalyticsSuccess
  | GetVisitorAnalyticsFailed
  | GetRiskProfile
  | GetRiskProfileNewSuccess
  | GetRiskProfileNewFailed;
